import React, { FC, ReactElement, useContext } from 'react'
import { SelfProvisioning as SelfProvisioningLanguage } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import Button from '../../Common/Components/Button'
import Icon, { IconName } from '../../Common/Components/Icon'
import { LanguageContext } from '../../Common/Contexts'
import { ModalContext, ModalContextType } from '../../Common/Contexts/ModalContext'
import UserInfoContext, { UserInfoContextType } from '../../Common/Contexts/UserInfoContext'

/**
 * View the user sees upon completing the self provisioning process.
 */
export const CompletedView: FC = (): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler
    const currentUser: UserInfoContextType = useContext(UserInfoContext)
    const { closeModal }: ModalContextType = useContext(ModalContext)

    return (
        <div className='completed-view'>
            <Icon className='success-icon' iconName={IconName.SUCCESS} />

            <div className='cv-title'>
                {language.get(SelfProvisioningLanguage.SelfProvisioning_CompletedView_Title)}
            </div>

            <div className='cv-content'>
                {language.getInterpolated(
                    SelfProvisioningLanguage.SelfProvisioning_CompletedView_SentTo,
                    currentUser?.EmailAddr ?? ''
                )}
            </div>

            <div className='cv-close-container'>
                <Button
                    label={language.get(SelfProvisioningLanguage.SelfProvisioning_CompletedView_Close)}
                    onClick={closeModal}
                />
            </div>
        </div>
    )
}
